import { Routes, RouterModule } from '@angular/router';
import { PaymentCreditScreenComponent } from './payment-credit.component';

const paymentCreditRoutes: Routes = [
];

export const PaymentCreditRouter = RouterModule.forChild(paymentCreditRoutes);